export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function delayedFunction<T extends (...args: any[]) => any>(fn: T, ms: number) {
  return (async (...args: Parameters<T>) => {
    const [result] = await Promise.all([fn(...args), sleep(ms)])
    return result
  }) as T
}

export async function copyToClipboard(text: string): Promise<void> {
  if (!navigator.clipboard) {
    throw new Error('Clipboard API is not available')
  }
  await navigator.clipboard.writeText(text)
}

export function triggerBlobDownload(blob: Blob, filename: string): void {
  const blobUrl = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = blobUrl
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  setTimeout(() => URL.revokeObjectURL(blobUrl), 100)
}

export async function downloadFile(url: string, filename: string): Promise<void> {
  try {
    const res = await fetch(url)
    if (!res.ok) return
    const blob = await res.blob()
    triggerBlobDownload(blob, filename)
  } catch {
    // network failure, CORS, or third-party extension interference — fail silently
  }
}
